const getLoading = state => state.lead.filterStatus.loading;

const getFiltersSelected = state => state.lead.filterStatus.filtersSelected;

const getFiltersTotalState = state => state.lead.filterStatus.filtersTotalState;

const getIsEmptySelectedFilters = state => state.lead.filterStatus.filtersSelected.length === 0;

export { getLoading, getFiltersSelected, getFiltersTotalState, getIsEmptySelectedFilters };
